import { render } from "./CenterPanel.vue?vue&type=template&id=4b1e5029"
import script from "./CenterPanel.vue?vue&type=script&lang=js"
export * from "./CenterPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__